<template>

  <div class="bg-white px-3 index">
    <div class="add_tits" ref="titles">
      <el-form class="form-inlines" :inline="true">
        <div class="u-f u-ac ">
          <el-form-item label="时间">
            <el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="status" placeholder="请选择" size="small" clearable>
              <el-option label="未审核" value="-1"> </el-option>
              <el-option label="通过" value="1"></el-option>
              <el-option label="未通过" value="2">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="begin">搜索
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" border :height="height" v-loading='tabloading'>
      <el-table-column prop="id" label="编号"> </el-table-column>
      <el-table-column prop="author_text" label="用户名" show-overflow-tooltip=""> </el-table-column>
      <el-table-column prop="create_time" label="发布时间" show-overflow-tooltip=""> </el-table-column>
      <el-table-column prop="name" label="问题内容" show-overflow-tooltip=""> </el-table-column>
      <el-table-column prop="disease_type_text" label="标签" show-overflow-tooltip=""> </el-table-column>
      <el-table-column prop="money" label="答题奖励" show-overflow-tooltip=""> </el-table-column>
      <el-table-column prop="status" label="是否分配">
        <template slot-scope="scope">{{
            scope.row.distribute == 1 ? "是" : "否"
          }}</template>
      </el-table-column>
      <el-table-column prop="state" label="状态">
        <template slot-scope="scope">{{
            scope.row.reply == 1 ? "已回复" : "未回复"
          }}</template>
      </el-table-column>
      <el-table-column prop="operate" label="操作" width="250px">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="openfp(row)">分配</el-button>
          <el-button type="text" size="small" @click="openjl(row)">答题奖励</el-button>
          <el-button type="text" size="small" @click="openhdlist(row)">回答详情</el-button>
          <el-button type="text" size="small" @click="openbq(row)">标签</el-button>
          <el-button type="text" size="small" @click="clear(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="u-f u-ac u-jsb ft_mr">
      <div></div>
      <div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[15, 30, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="分配" :visible.sync="dialogTableVisible" top="50px" width="60%">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane v-for="(t,index) in tabs" :key="index" :label="t.text" :name="t.id">
          <div>
            <el-form ref="form" :model="form" label-width="80px" :inline="true">
              <el-form-item label="医生" v-if="index==0">
                <el-input v-model="form.docname" size="small" placeholder="输入医生姓名"></el-input>
              </el-form-item>
              <el-form-item label="科室" v-if="index==1">
                <el-select v-model="form.keshi" clearable placeholder="请选择科室" size="small" multiple>
                  <el-option v-for="item in ks_options" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职称" v-if="index==1">
                <el-select v-model="form.zhicheng" clearable placeholder="请选择职称" size="small" multiple>
                  <el-option v-for="item in job_options" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="searchZD">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

        </el-tab-pane>
      </el-tabs>
      <div>
        <div class="u-f">
          <div style="width:50%">
            <el-table :data="userTableData" border v-loading="selectusersloading" height="490px"
              ref="configurationTables" @selection-change="handleSelectionChange" :row-key="getRowKeys">
              <el-table-column type="selection" width="55" :reserve-selection="true" />
              <el-table-column prop="title" label="头像" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-image style="width: 50px; height: 50px;border-radius:50%"
                    v-if="scope.row.head_portrait_pic&&scope.row.head_portrait_pic.length>0"
                    :src="scope.row.head_portrait_pic[0].url" fit="cover">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.real_name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="department_id_text" label="科室" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
          <div style="width:50%;margin-left:10px">
            <el-table :data="selectusers" border v-loading="selectusersloading" height="490px" ref="configurationTable">
              <el-table-column prop="title" label="头像" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-image style="width: 50px; height: 50px;border-radius:50%"
                    v-if="scope.row.head_portrait_pic&&scope.row.head_portrait_pic.length>0"
                    :src="scope.row.head_portrait_pic[0].url" fit="cover">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.real_name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="department_id_text" label="科室" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </div>
        <!-- <div class="u-f u-ac u-jsb ft_mr">
              <div>
                <el-pagination @size-change="userhandleSizeChange" @current-change="userhandleCurrentChange"
                  :current-page="usercurrentPage" :page-sizes="[10, 20, 30, 40]" :page-size="userpagesize"
                  layout="total, sizes, prev, pager, next" :total="usercount">
                </el-pagination>
              </div>
            </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="fpsubmit" :loading='fploading'>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="答题奖励" :visible.sync="dialogTableVisible2">
      <el-form ref="form" :model="award" label-width="80px">
        <el-form-item label="奖励金额">
          <el-input v-model="award.value" size="small" type="number" style="max-width: 100px; margin-right: 10px"
            min="0">
          </el-input>
          <span>¥</span>
          <div style="color:red">如果此处不填写，直接显示统一金额，如果填写，则以此处为准。</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="jlsubmit" :loading='jlloading'>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="回答详情" :visible.sync="dialogTableVisible3" top="50px" width="70%">
      <el-form class="form-inlines" :inline="true">
        <div class="u-f u-ac ">
          <el-form-item label="状态">
            <el-select v-model="answer_status" placeholder="请选择" size="small" clearable>
              <el-option label="未审核" value="0"> </el-option>
              <el-option label="通过" value="1"></el-option>
              <el-option label="未通过" value="2">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchgetanswerList">搜索
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <div style=" overflow: auto" :style="{height:answer_height}" v-loading='answer_loading'>
        <el-empty description="暂无回答" v-if="answerList.length==0"></el-empty>
        <div class="answer" v-for="(item, index) in answerList" :key="index">
          <div class="answer_title u-f u-ac">
            <el-image style="width: 30px; height: 30px;border-radius:50%"
              v-if="item.head_portrait_pic&&item.head_portrait_pic.length>0" :src="item.head_portrait_pic[0].url"
              fit="cover"></el-image>
            <span>{{ item.real_name }}</span>
            <span>|</span>
            <span>{{ item.competent_id_text }}</span>
            <span>{{ item.hospital_id_text }}</span>
            <span>{{ item.create_time }}</span>
          </div>
          <div class="answer_con_b">
            <div class="answer_content">
              {{ item.reply_content }}
            </div>
            <div class="examine_btn_b">
              <div style="margin-bottom:5px">
                <el-tag v-for="item in answer_status_show.filter(a=>{return a.id==item.reply_check})" size="small"
                  :key="item.label" :type="item.type" effect="dark">
                  {{ item.label }}
                </el-tag>
              </div>
              <div>
                <i class="el-icon-delete del" title="删除" @click="answer_del(item)"></i>
                <i class="el-icon-circle-close cha" title="不通过" @click="openansweramine(item)"></i>
                <i class="el-icon-circle-check dui" title="通过" @click="answerexamine(item,1)"></i>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class='u-f u-jsb' style="">
        <div></div>
        <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
          :current-page="currentPage2" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize2"
          layout="total, sizes, prev, pager, next, jumper" :total="tatol">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="标签" :visible.sync="dialogTableVisible4">
      <div>
        <el-checkbox-group v-model="checkList">
          <el-checkbox size="small" :label="l.id" border v-for="(l,index) in labels" :key="index"
            style="margin-bottom:20px">{{l.content_name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="bqsubmit" :loading='bqloading'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex';
  export default {
    data() {
      return {
        times: [],
        //主页列表
        tableData: [],
        currentPage: 1,
        pagesize: 15,
        count: 0,
        tabloading: false,
        tabs: [{
            id: '1',
            text: '手动分配'
          },
          {
            id: '2',
            text: '自动分配'
          },
        ],
        job_options: [],
        ks_options: [],
        userTableData: [],
        seleteUserTableData: [],
        usercurrentPage: 1,
        userpagesize: 10,
        usercount: 0,
        //手动页勾选
        selectusers: [],
        selectusersloading: false,

        //自动页勾选
        multipleSelection2: [],
        //分配
        dialogTableVisible: false,
        //答题奖励
        dialogTableVisible2: false,
        //回答详情
        dialogTableVisible3: false,
        //标签
        dialogTableVisible4: false,
        //分配标签页
        activeName: '1',
        //手动分配搜索框
        input: "",
        //自动分配下拉框value
        form: {
          zhicheng: [],
          keshi: [],
          docname: '',
        },
        //答题奖励输入框
        award: {
          value: 5,
        },
        //回答详情列表
        answerList: [],
        //回答详情分页
        currentPage2: 1,
        pagesize2: 10,
        tatol: 0,
        //标签选择
        labels: [],
        checkList: [],
        height: null,
        fploading: false,
        jlloading: false,
        bqloading: false,
        q_id: '',
        answer_status: '',
        answer_height: null,
        answer_loading: false,
        answer_status_show: [{
            type: 'info',
            label: '待审核',
            id: 0
          },
          {
            type: 'success',
            label: '审核已通过',
            id: 1
          },

          {
            type: 'danger',
            label: '审核不通过',
            id: 2
          },
        ],
        answer_money: 0,
        status:'',
      };
    },
    mounted() {
      this.getHeight()
      this.getjob()
      this.getks()
      this.searchZD()
      this.getlabel()
      this.begin()
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      getHeight() {
        let that = this;
        var titles = that.$refs.titles.offsetHeight;
        that.height = window.innerHeight - titles - 200 + "px";
        that.answer_height = window.innerHeight - 310 + "px";
        window.onresize = () => {
          var titles = that.$refs.titles.offsetHeight;
          that.height = window.innerHeight - titles - 200 + "px";
          that.answer_height = window.innerHeight - 310 + "px";
        };
      },
      async getlabel() {
        this.axios.post('/admin/dictionaryQuestionLabel/list', {
          page: 1,
          page_count: 100
        }, {
          token: true
        }).then(res => {
          if (res.data.code == 200) {
            this.labels = res.data.data.list
          }
        })
      },
      begin() {
        this.currentPage = 1
        this.search()
      },
      async search() {
        this.tabloading = true
        this.axios.post('/admin/dictionaryQuestion/list', {
          page: this.currentPage,
          page_count: this.pagesize,
          check:this.status,
          start:this.times?this.times[0]:'',
          end:this.times?this.times[1]:'',
        }, {
          token: true
        }).then(res => {
          this.tabloading = false
          if (res.data.code == 200) {
            this.tableData = res.data.data.list
            this.count = res.data.data.totalCount
          }
        })
      },
      handleSizeChange(val) {
        this.pagesize = val
        this.search()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.search()
      },
      getjob() {
        axios
          .post("/admin/showCompetentList", {}, {
            token: true
          })
          .then(response => {
            this.job_options = this.IterDelateChildren(response.data.data)
          })
          .catch(error => {})
      },
      getks() {
        axios
          .post("/admin/showSectionList", {}, {
            token: true
          })
          .then(response => {
            this.ks_options = this.IterDelateChildren(response.data.data)
          })
          .catch(error => {})
      },
      IterDelateChildren(arr) {
        let list = []
        let fn = function (arr, list) {
          arr.forEach(ele => {
            if (ele.children && ele.children.length > 0) {
              fn(ele.children, list)
            } else {
              delete ele.children
              list.push(ele)
            }
          })
          return list
        }
        return fn(arr, list)
      },
      doc_search() {
        let that = this
        this.selectusersloading = true
        axios
          .post("/admin/dictionaryQuestion/doctorList", {
            // page: that.usercurrentPage,
            // page_count: that.userpagesize,
            keyword: this.form.docname,
            competent_id: this.form.zhicheng,
            department_id: this.form.keshi,

          }, {
            token: true
          })
          .then(response => {
            this.selectusersloading = false
            that.userTableData = response.data.data
            // that.count = response.data.data.totalCount

          })
          .catch(error => {})
      },
      userhandleSizeChange(val) {
        let that = this
        that.userpagesize = val;
        that.doc_search()
      },
      userhandleCurrentChange(val) {
        let that = this
        that.usercurrentPage = val;
        that.doc_search()
      },
      getRowKeys(row) {
        return row.id; // id为列表数据的唯一标识
      },
      openjl(a) {
        this.dialogTableVisible2 = true
        this.award.value = a.money
        this.q_id = a.id
      },
      openfp(a) {
        this.q_id = a.id
        this.dialogTableVisible = true
      },
      openbq(a) {
        this.q_id = a.id
        this.dialogTableVisible4 = true
        this.checkList = a.disease_type.split(',').map(Number)

      },
      openhdlist(a) {
        this.q_id = a.id
        this.answer_money = a.question_money
        this.dialogTableVisible3 = true
        this.answer_status = ''
        this.searchgetanswerList()
      },
      searchgetanswerList() {
        this.currentPage2 = 1
        this.getanswerList()
      },
      getanswerList() {
        this.answer_loading = true
        this.axios.post('/admin/dictionaryQuestion/commentDetail', {
          dictionary_question_id: this.q_id,
          page: this.currentPage2,
          page_count: this.pagesize2,
          reply_check: this.answer_status
        }, {
          token: true
        }).then(res => {
          this.answer_loading = false
          this.answerList = res.data.data.list
          this.tatol = res.data.data.count
        })
      },
      answerexamine(a, t, click, message) {
        let money = (this.answer_money + '').indexOf('.') != -1 ? this.answer_money : (this.answer_money - 0).toFixed(2)
        this.axios.post('/admin/dictionaryQuestion/checkReply', {
          reply_check: t,
          user_id: this.user.user.id,
          doc_id: a.create_user,
          money: money,
          check_remark: message,
          id: a.id
        }, {
          token: true
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('审核成功！')
            this.getanswerList()
            if (t == 2) {
              click()
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })

      },
      openansweramine(a) {
        let that = this
        this.$prompt('请输入不通过理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          beforeClose(action, instance, done) {
            if (action == 'confirm') {
              if (!instance.inputValue) return that.$message('请输入拒绝理由！')
              that.answerexamine(a, 2, done, instance.inputValue)
            } else {
              done()
            }
          }

        }).then(({
          value
        }) => {

        }).catch(() => {

        });
      },
      answer_del(a) {
        this.$confirm('此操作将永久删除该回答, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post('/admin/dictionaryQuestionComment/del', {
            id: a.id,
          }, {
            token: true
          }).then(res => {
            if (res.data.code == 200) {
              this.$message.success('删除成功！')
              this.getanswerList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }).catch(() => {

        });

      },


      //分配标签页
      handleClick(tab) {
        if (tab.index == 0) {
          this.form.keshi = []
          this.form.zhicheng = []
        } else if (tab.index == 1) {
          this.form.docname = ''
        }
      },
      //自动页搜索
      searchZD() {
        this.usercurrentPage = 1
        this.doc_search()
        //点击查询后出来列表自动全选

      },
      //手动页点击勾选
      handleSelectionChange(val) {
        this.selectusers = val;
      },
      fpsubmit() {
        if (this.selectusers.length == 0) return this.$message('请选择医生')
        this.fploading = true
        let array = this.selectusers.map(a => {
          return a.user_id
        })
        this.axios.post('/admin/dictionaryQuestion/distribute', {
          user_id: array,
          dictionary_question_id: this.q_id,
          author: this.user.user.id,
        }, {
          token: true
        }).then(res => {
          this.fploading = false
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.dialogTableVisible = false
            this.search()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      jlsubmit() {
        if (this.award.value < 0) return this.$message('金额最小为0')
        this.jlloading = true

        this.axios.post('/admin/dictionaryQuestion/setMoney', {
          id: this.q_id,
          money: this.award.value,
        }, {
          token: true
        }).then(res => {
          this.jlloading = false
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.dialogTableVisible2 = false
            this.search()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      bqsubmit() {
        if (this.checkList.length < 1) return this.$message('请选择标签')
        this.bqloading = true
        this.axios.post('/admin/dictionaryQuestion/setLabel', {
          id: this.q_id,
          disease_type: this.checkList.toString(),
        }, {
          token: true
        }).then(res => {
          this.bqloading = false
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.dialogTableVisible4 = false
            this.search()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      //回答详情弹框分页
      handleSizeChange2(val) {
        this.pagesize2 = val
        this.getanswerList()

      },
      handleCurrentChange2(val) {
        this.currentPage2 = val
        this.getanswerList()

      },
      //删除
      clear(a) {
        this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.axios.post('/admin/dictionaryQuestion/del', {
              id: a.id,
            }, {
              token: true
            }).then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.msg)
                this.search()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },

    },
  };
</script>

<style scoped lang='scss'>
  .answer {
    /* height: 100px; */
    background-color: #f8f8f8;
    border-radius: 10px;
    padding: 5px;
    margin-bottom: 10px;
  }

  .answer_title span {
    margin-left: 8px;
    color: #222;
  }

  .answer_con_b {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 10px;
  }

  .answer_content {

    min-height: 55px;
    flex: 1;

  }

  .examine_btn_b {
    width: 120px;
    font-size: 25px;
    text-align: right;

    i {
      margin-right: 8px;
    }

    .cha:hover {
      color: rgb(219, 168, 0);
    }

    .dui:hover {
      color: #0078ff;
    }

    .del:hover {
      color: red;
    }

  }
</style>